import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
export const News = () => {
      // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="w-[96%] mx-auto pt-6">
   <h1 className="font-semibold jakarta-font">{t("help")}</h1>
   <div className="flex pt-2">
    <h1>There have no current updated news</h1>
    <button className="pl-2 text-light-blue" type="button">
     Update now!
    </button>
   </div>
   <div className="flex items-center lg:justify-between mt-6">
    <Box bg="highlight" className="jakarta-font py-4 px-4 text-xs lg:w-[80%]">
     <h1>
      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
      been the industrys standard dummy text ever since the 1500s, when an unknown printer took a
      galley of type and scrambled it to make a type specimen book. It has survived not only five
      centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It
      was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum
      passages, and more recently with desktop publishing software like Aldus PageMaker including
      versions of Lorem Ipsum.
     </h1>
    </Box>
    <h1>02/02/2023 (10:30)</h1>
   </div>
  </div>
 )
}
